var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 3.5,
    fill: "#E46666",
    fillOpacity: 0.14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 3.5,
    stroke: "#CD0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 8.14706H19.6668M11.3335 16.9706V11.6765M14.6668 16.9706V11.6765M16.3335 20.5H9.66683C8.74636 20.5 8.00016 19.7099 8.00016 18.7353V9.02941C8.00016 8.5421 8.37326 8.14706 8.8335 8.14706H17.1668C17.6271 8.14706 18.0002 8.5421 18.0002 9.02941V18.7353C18.0002 19.7099 17.254 20.5 16.3335 20.5ZM11.3335 8.14706H14.6668C15.1271 8.14706 15.5002 7.75202 15.5002 7.26471V6.38235C15.5002 5.89504 15.1271 5.5 14.6668 5.5H11.3335C10.8733 5.5 10.5002 5.89504 10.5002 6.38235V7.26471C10.5002 7.75202 10.8733 8.14706 11.3335 8.14706Z",
    stroke: "#CD0000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.c4b730ed4fbc4c376908b538e77a5504.svg";
export { ForwardRef as ReactComponent };